/* eslint-disable import/prefer-default-export */
import DiscountCouponRequests from '../../server/discountCoupon';
import { addLoading, removeLoading } from './loading';


export const createDiscountCoupon = newDiscountCoupon => async (dispatch) => {
  dispatch(addLoading());
  try {
    await DiscountCouponRequests.createDiscountCoupon(newDiscountCoupon);
  } finally {
    dispatch(removeLoading());
  }
};

export const getListDiscountCoupon = (limit, skip, search, orderBy, field) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await DiscountCouponRequests.getListDiscountCoupon(limit, skip, search, orderBy, field);
  } finally {
    dispatch(removeLoading());
  }
};

export const getDiscountCouponHistory = (limit, skip, search, orderBy, field) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await DiscountCouponRequests.getDiscountCouponHistory(limit, skip, search, orderBy, field);
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvDiscountCouponModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await DiscountCouponRequests.getCsvDiscountCouponModel();
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadCsvDiscountCoupon = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await DiscountCouponRequests.uploadCsvDiscountCoupon(file);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateDiscountCoupon = discountCouponParameter => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await DiscountCouponRequests.updateDiscountCoupon(discountCouponParameter);
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteDiscountCoupon = couponId => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await DiscountCouponRequests.deleteDiscountCoupon(couponId);
  } finally {
    dispatch(removeLoading());
  }
};
